import { Link } from 'react-router-dom';

interface PopularCard {
  icon: string;
  title: string;
  description: string;
  to: string;
}

const popularCards: PopularCard[] = [
  {
    icon: 'ri-book-open-line',
    title: 'Что такое корпоративное обучение',
    description: 'Базовое руководство по организации обучения в компании: виды, форматы, преимущества и ключевые метрики.',
    to: '/enciklopediya-korporativnogo-obucheniya/chto-takoe-korporativnoe-obuchenie',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Обучение отдела продаж',
    description: 'Как повысить конверсию, увеличить средний чек и построить долгосрочные отношения с клиентами.',
    to: '/enciklopediya-korporativnogo-obucheniya/obuchenie-otdela-prodazh',
  },
  {
    icon: 'ri-building-line',
    title: 'Корпоративная академия',
    description: 'Пошаговое руководство по созданию внутреннего учебного центра компании для системного развития сотрудников.',
    to: '/enciklopediya-korporativnogo-obucheniya/korporativnaya-akademiya',
  },
  {
    icon: 'ri-shield-star-line',
    title: 'Тренинг для руководителей',
    description: 'Развитие лидерских качеств и управленческих компетенций для руководителей всех уровней.',
    to: '/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley',
  },
  {
    icon: 'ri-chat-smile-3-line',
    title: 'Soft Skills',
    description: 'Почему гибкие навыки важнее технических и как развивать их в команде для роста эффективности.',
    to: '/enciklopediya-korporativnogo-obucheniya/razvitie-soft-skills',
  },
  {
    icon: 'ri-group-line',
    title: 'Командообразование',
    description: 'Современные методики сплочения коллектива: от бизнес-игр до стратегических сессий развития.',
    to: '/enciklopediya-korporativnogo-obucheniya/komandoobrazovanie',
  },
  {
    icon: 'ri-bar-chart-box-line',
    title: 'Оценка эффективности обучения',
    description: 'Как измерить результативность тренингов: модель Киркпатрика, ROI, метрики и KPI.',
    to: '/enciklopediya-korporativnogo-obucheniya/ocenka-effektivnosti-obucheniya',
  },
];

export default function PopularMaterials() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Популярные материалы
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Самые читаемые статьи и руководства по корпоративному обучению. Выберите интересующую тему и углубитесь в неё.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {popularCards.map((card, index) => (
            <Link
              key={index}
              to={card.to}
              className="group bg-white rounded-xl p-6 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-600 transition-colors duration-300">
                <i className={`${card.icon} text-xl text-teal-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                {card.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4 flex-1">
                {card.description}
              </p>
              <span className="inline-flex items-center text-teal-600 font-semibold text-sm group-hover:gap-2 transition-all gap-1 whitespace-nowrap">
                Подробнее <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          ))}
          {/* Last card spans full width for 7 items on 3-column grid */}
          <div className="hidden lg:block lg:col-span-3"></div>
        </div>
      </div>
    </section>
  );
}